/**
 * /support — Surface Layer (/01)
 *
 * Public support page (Auth Flow v2). Private beta has no self-serve
 * sign-up: e-mails that are not pre-registered cannot request sign-in
 * links, and this page is where they open an access request instead.
 */

import { createFileRoute } from '@tanstack/react-router';
import { Button, Link as CarbonLink, Stack, Theme } from '@carbon/react';
import { Help } from '@carbon/icons-react';
import './sign-in.scss';

export const Route = createFileRoute('/support')({
  component: SupportPage,
});

const SUPPORT_MAILTO =
  'mailto:mail@cestari.studio?subject=Workspace%20access%20request&body=Your%20name%3A%0AYour%20e-mail%3A%0AOrganization%3A%0AWho%20invited%20you%20(if%20known)%3A%0A';

function SupportPage() {
  return (
    <Theme theme="g100">
      <main className="sign-in-page">
        <section className="sign-in-card" aria-labelledby="support-heading">
          <Help size={32} aria-hidden="true" className="sign-in-card__icon" />
          <h1 id="support-heading" className="sign-in-card__heading">
            Support
          </h1>
          <p className="sign-in-card__subtitle">
            This workspace is in private beta — accounts are created by invitation only. If your
            e-mail is not registered, open an access request and the workspace operator will
            review it.
          </p>

          <Stack gap={5}>
            <Button kind="primary" href={SUPPORT_MAILTO}>
              Open an access request
            </Button>
            <CarbonLink href="/sign-in">Back to sign-in</CarbonLink>
          </Stack>
        </section>
      </main>
    </Theme>
  );
}
